/******/ (() => { // webpackBootstrap
/* eslint-disable */
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.cacheDOMElements();
      this.bindEventHandlers();
    }

    cacheDOMElements() {
      /* ===== We need to cache the DOM elements in the constructor because the connectedCallback is called every time the element 
      is appended into the DOM ===== */
      this.input = this.querySelector('input');
      this.buttonMinus = this.querySelector("button[name='minus']");
      this.buttonPlus = this.querySelector("button[name='plus']");
      this.sectionId = this.getAttribute('data-section-id');
      this.isB2BQuantity = this.getAttribute('data-b2b-quantity') === 'true';
    }

    bindEventHandlers() {
      /* ===== Bind the event handlers in order to maintain the correct context of 'this' ===== */
      this.attachEventListeners = this.attachEventListeners.bind(this);
      this.detachEventListeners = this.detachEventListeners.bind(this);
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onInput = this.debounce(this.onInput.bind(this), 500);
      this.onCartAdded = this.onCartAdded.bind(this);
    }

    connectedCallback() {
      this.attachEventListeners();
      // Sync hidden quantity input on initial load (with small delay to ensure DOM is ready)
      setTimeout(() => {
        this.syncHiddenQuantityInput();
      }, 0);
    }
    
    syncHiddenQuantityInput() {
      /* ===== Sync the hidden quantity input with the visible input value ===== */
      if (!this.input || !this.input.value) return;
      
      const quantityValue = this.input.value;
      
      // Emit event for product-information component to handle
      eventBus.emit('qty:change', { value: quantityValue, sectionId: this.sectionId });
      
      // Also directly update hidden input as fallback
      const productForm = this.closest('product-form') || document.querySelector(`product-form[data-section-id="${this.sectionId}"]`);
      if (productForm) {
        const hiddenQuantityInput = productForm.querySelector('input[name="quantity"]');
        if (hiddenQuantityInput) {
          hiddenQuantityInput.value = quantityValue;
        }
      }
    }

    attachEventListeners() {
      /* ===== Attach the event listeners to the DOM elements ===== */
      this.buttonMinus.addEventListener('click', this.onButtonClick);
      this.buttonPlus.addEventListener('click', this.onButtonClick);
      this.input.addEventListener('input', this.onInput);
      eventBus.on('cart:added', this.onCartAdded);
    }

    debounce(func, wait, immediate) {
      /* ===== Debounce function to limit the rate at which a function is called ===== */
      let timeout;
      return function executedFunction() {
        const context = this;
        const args = arguments;
        
        const later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };

        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    onButtonClick(event) {
      /* ===== Handle the button click event ===== */
      event.preventDefault();
      const previousValue = this.input.value;
      const adjustment = event.currentTarget.name === 'plus' ? (this.isB2BQuantity ? 3 : 1) : (this.isB2BQuantity ? -3 : -1);

      // Adjust the quantity by the adjustment value
      this.adjustQuantity(adjustment);
      // Sync hidden quantity input if the value has changed
      if (previousValue !== this.input.value) {
        this.syncHiddenQuantityInput();
      }
    }

    onInput(event) {
      /* ===== Handle the input event ===== */
      event.preventDefault();

      // If the value is not a number, set it to min value
      if (isNaN(this.input.value)) {
        this.input.value = this.isB2BQuantity ? 3 : 1;
      }

      let quantity = parseInt(this.input.value);
      
      // For B2B quantity, ensure it's a multiple of 3 and at least 3
      if (this.isB2BQuantity) {
        if (quantity < 3) {
          quantity = 3;
        } else {
          // Round to nearest multiple of 3
          quantity = Math.round(quantity / 3) * 3;
          if (quantity < 3) quantity = 3;
        }
        this.input.value = quantity;
      } else {
        // If the value is smaller than the min attribute, set it to the min attribute
        if (this.input.min && quantity < parseInt(this.input.min)) {
          this.input.value = this.input.min;
        }
      }

      // Sync hidden quantity input
      this.syncHiddenQuantityInput();
    }

    adjustQuantity(adjustment) {
      /* ===== Adjust the quantity by the adjustment value ===== */
      const currentValue = parseInt(this.input.value) || (this.isB2BQuantity ? 3 : 1);
      let newValue = currentValue + adjustment;
      
      // For B2B quantity, ensure it's always a multiple of 3 and at least 3
      if (this.isB2BQuantity) {
        if (newValue < 3) {
          newValue = 3;
        } else {
          // Round to nearest multiple of 3
          newValue = Math.round(newValue / 3) * 3;
          if (newValue < 3) newValue = 3;
        }
      } else {
        // If the new value is not a number, set it to 1
        if (isNaN(newValue)) {
          newValue = 1;
        }
        // If the value is smaller than the min attribute, set it to the min attribute
        if (this.input.min && newValue < parseInt(this.input.min)) {
          newValue = parseInt(this.input.min);
        }
      }
      
      this.input.value = newValue;
    }

    onCartAdded(data) {
      /* ===== Handle the cart:added event and reset the input value ===== */
      if (data.sectionId && data.sectionId === this.sectionId) {
        const resetValue = this.isB2BQuantity ? 3 : 1;
        this.input.value = resetValue;
        // Sync hidden quantity input after reset
        this.syncHiddenQuantityInput();
      }
    }

    disconnectedCallback() {
      /* ===== Detach the event listeners when the element is removed from the DOM ===== */
      this.detachEventListeners();
    }

    detachEventListeners() {
      /* ===== Detach the event listeners from the DOM elements ===== */
      this.buttonMinus.removeEventListener('click', this.onButtonClick);
      this.buttonPlus.removeEventListener('click', this.onButtonClick);
      this.input.removeEventListener('input', this.onInput);
    }
  });
}
/******/ })()
;